/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_HiddenInputs */

const en_link_editor_hidden = /** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const es_link_editor_hidden = /** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oculto`)
};

const fr_link_editor_hidden = /** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masqué`)
};

const de_link_editor_hidden = /** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versteckt`)
};

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const ja_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const zh_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const ar_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const id_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const it_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const ru_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const pt_link_editor_hidden = en_link_editor_hidden;

/** @type {(inputs: Link_Editor_HiddenInputs) => LocalizedString} */
const ko_link_editor_hidden = en_link_editor_hidden;

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Link_Editor_HiddenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_hidden = /** @type {((inputs?: Link_Editor_HiddenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_HiddenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_hidden(inputs)
	if (locale === "es") return es_link_editor_hidden(inputs)
	if (locale === "fr") return fr_link_editor_hidden(inputs)
	if (locale === "de") return de_link_editor_hidden(inputs)
	if (locale === "ja") return ja_link_editor_hidden(inputs)
	if (locale === "zh") return zh_link_editor_hidden(inputs)
	if (locale === "ar") return ar_link_editor_hidden(inputs)
	if (locale === "id") return id_link_editor_hidden(inputs)
	if (locale === "it") return it_link_editor_hidden(inputs)
	if (locale === "ru") return ru_link_editor_hidden(inputs)
	if (locale === "pt") return pt_link_editor_hidden(inputs)
	return ko_link_editor_hidden(inputs)
});